
import React from 'react';
import { motion } from 'framer-motion';
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver';
import './Cosmos.css';

const Cosmos = () => {
    const [ref, isVisible] = useIntersectionObserver();

    return (
        <section className="cosmos-container-wrapper" ref={ref} id="cosmos">
            <div className="container">
                <motion.div
                    className="cosmos-header-center"
                    initial={{ opacity: 0, y: 20 }}
                    animate={isVisible ? { opacity: 1, y: 0 } : {}}
                    transition={{ duration: 0.6 }}
                >
                    <br />
                    <h3 className="cosmos-main-display-title">Cosmos: Our Execution Differentiator</h3>
                </motion.div>

                <div className="cosmos-content-split">
                    <motion.div
                        className="cosmos-vision-block"
                        initial={{ opacity: 0, x: -30 }}
                        animate={isVisible ? { opacity: 1, x: 0 } : {}}
                        transition={{ duration: 0.6, delay: 0.2 }}
                    >
                        <h4 className="cosmos-vision-headline">
                            Strategy fails without governance.<br />
                            Execution fails without a system.
                        </h4>
                        <div className="cosmos-vision-body">
                            <p>
                                COSMOS is Triology’s proprietary <strong>Consulting & Project Management Operating System</strong>,
                                purpose-built to bridge the gap between intent and results.
                            </p>
                            <p className="cosmos-accent-statement">
                                We help organizations move from <strong>planning to consistent performance.</strong>
                            </p>
                        </div>
                    </motion.div>

                    <motion.div
                        className="cosmos-feature-card"
                        initial={{ opacity: 0, x: 30 }}
                        animate={isVisible ? { opacity: 1, x: 0 } : {}}
                        transition={{ duration: 0.6, delay: 0.3 }}
                    >
                        <div className="cosmos-card-inner">
                            <h5 className="cosmos-card-label">The COSMOS Advantage:</h5>
                            <ul className="cosmos-feature-list">
                                <li>
                                    <span className="cosmos-dot"></span>
                                    <span>Clear roles and accountability frameworks</span>
                                </li>
                                <li>
                                    <span className="cosmos-dot"></span>
                                    <span>Milestone-driven execution tracking</span>
                                </li>
                                <li>
                                    <span className="cosmos-dot"></span>
                                    <span>Structured reviews and decision cadence</span>
                                </li>
                                <li>
                                    <span className="cosmos-dot"></span>
                                    <span>Real-time visibility into progress and outcomes</span>
                                </li>
                            </ul>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default Cosmos;
